import { useCallback, useState } from "react";

export default function useStepNavigation(initialStep = 1) {
  const [navigation, setNavigation] = useState({ step: initialStep, history: [] });
  const goToStep = useCallback((step) => {
    setNavigation((current) => current.step === step ? current : {
      step, history: [...current.history, current.step],
    });
  }, []);
  const goBack = useCallback((fallback) => {
    setNavigation((current) => ({
      step: current.history.length ? current.history[current.history.length - 1] : fallback,
      history: current.history.slice(0, -1),
    }));
  }, []);
  const restoreStep = useCallback((step) => setNavigation({ step, history: [] }), []);
  return { step: navigation.step, goToStep, goBack, restoreStep };
}
